import { render, staticRenderFns } from "./BasePublishPostModal.vue?vue&type=template&id=e205e914&scoped=true&"
import script from "./BasePublishPostModal.vue?vue&type=script&lang=js&"
export * from "./BasePublishPostModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e205e914",
  null
  
)

export default component.exports